import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuthenticatedUser, Club } from '~core/models';
import { CustomerService, NavigationService, StorageService } from '~core/services';

/**
 * Base component for the sidebar content.
 */
@UntilDestroy()
@Component({
  selector: 'app-sidebar-base',
  template: ''
})
export class SidebarBaseComponent implements OnDestroy {
  public authenticatedUser: AuthenticatedUser;
  public currentId: number;
  public searchHistory: any;
  public selectedClub: Club;
  public isSearchOpened: boolean = true;
  public currentPage: string;
  public isCustomerProfileOpened: boolean = true;
  public basicSearchLink: string;
  public advancedSearchLink: string;

  constructor(
    public storage: StorageService,
    public route: ActivatedRoute,
    public navigationService: NavigationService,
    public customerService: CustomerService,
    public router: Router
  ) {
    if (this.storage.isLoggedIn()) {
      this.storage.authenticatedUser
        .pipe(untilDestroyed(this))
        .subscribe((user: AuthenticatedUser) => this.authenticatedUser = user);
    }
    this.storage.castCustomerSearchHistory
      .pipe(untilDestroyed(this))
      .subscribe(searchHistory => this.searchHistory = searchHistory);
    this.storage.castSelectedClub
      .pipe(untilDestroyed(this))
      .subscribe(club => (this.selectedClub = club));
    this.route.firstChild.params
      .pipe(untilDestroyed(this))
      .subscribe(params => this.currentId = params['id']);
    this.navigationService.castCurrentPage
      .pipe(untilDestroyed(this))
      .subscribe(data => this.currentPage = data);

    this.basicSearchLink = `/club/${this.selectedClub.id}/search/basic`;
    this.advancedSearchLink = `/club/${this.selectedClub.id}/search/advanced`;
  }

  /**
   * Toggles the menu item being opened or closed
   */
  public toggleIsCustomerProfileOpened(): void {
    this.isCustomerProfileOpened = !this.isCustomerProfileOpened;
  }

  /**
   * Function that opens up the last search result in the appropriate search page
   */
  public openLastSearch(): void {
    const lastSearch = this.searchHistory[this.selectedClub.id][0];
    this.customerService.setLastSearchResults(lastSearch);
    if (lastSearch.basic) {
      this.router.navigate([this.basicSearchLink]);
    } else {
      this.router.navigate([this.advancedSearchLink]);
    }
  }

  public ngOnDestroy(): void { }
}
